module.exports = __webpack_public_path__ + "img/jz2.38f30491.png";